import { createVoltraComponent } from './createVoltraComponent.js'
import type { SpacerProps } from './props/Spacer.js'

export type { SpacerProps }
export const Spacer = createVoltraComponent<SpacerProps>('Spacer')
